import { resolveBrandConfig } from "@dashboard/brands/brandConfig";
import CoreServicesBrand from "@dashboard/brands/CoreServicesBrand.vue";
import { mountBrandEntry } from "@dashboard/brands/mountBrandEntry";
import VodafoneHeader from "./VodafoneHeader.vue";
import VodafoneFooter from "./VodafoneFooter.vue";

const brand = "vodafone";
const config = resolveBrandConfig(brand);

mountBrandEntry({
  brand,
  dashboard: { component: CoreServicesBrand, props: { brand } },
  header: { component: VodafoneHeader },
  footer: {
    component: VodafoneFooter,
    props: {
      copyrightYearFrom: config.copyrightYearFrom,
      copyrightExtraText: config.copyrightExtraText,
    },
  },
});
